import { useQuery } from 'react-query';
import { InsurancePolicy } from '../../../../../../advisory-report/src/types/AdvisoryReport';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

export interface InsurencePoliciesResponse {
  items: InsurancePolicy[];
}

export interface InsurencePoliciesPartialResponse {
  items: Partial<InsurancePolicy>[];
}

interface Params {
  partyId: string;
}

const getInsurancePolicies = async ({ partyId }: Params) => {
  const { data, isError } = await wgApi.get<InsurencePoliciesResponse>(
    `/v1/api/parties/${partyId}/insurance-policies`,
  );
  if (isError) throw new Error();
  return data;
};

export const getUseInsurancePoliciesQKey = ({ partyId }: Params) => [
  'parties',
  'insurance-policies',
  partyId,
];

export const useInsurancePolicies = (params: Params) => {
  return useQuery(
    getUseInsurancePoliciesQKey(params),
    () => getInsurancePolicies(params),
    {
      enabled: !!params.partyId,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};
